/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import './style.css';

const MobileBottomNav = ({ location, isLogged, t, onWalletClick, onTradesClick, onChatClick, onMenuClick }) => {
  const isActive = (path) => {
    if (path === '/') {
      return location.pathname === path;
    }
    return location.pathname === path || location.pathname.startsWith(path + '/');
  };

  const handleWalletClick = (e) => {
    e.preventDefault();
    if (onWalletClick) {
      onWalletClick();
    }
  };

  const handleTradesClick = (e) => {
    e.preventDefault();
    if (onTradesClick) {
      onTradesClick();
    }
  };

  const handleChatClick = (e) => {
    e.preventDefault();
    if (onChatClick) {
      onChatClick();
    }
  };

  const handleMenuClick = (e) => {
    e.preventDefault();
    if (onMenuClick) {
      onMenuClick();
    }
  };

  return (
    <nav className="mobile-bottom-nav show">
      <div className="mobile-nav-container">
        <a
          href="/"
          className={`mobile-nav-item ${isActive('/') ? 'active1' : ''}`}
        >
          <div className="mobile-nav-icon">
            <i className="mdi mdi-home"></i>
          </div>
          <span className="mobile-nav-label">Home</span>
        </a>

        <button
          onClick={handleTradesClick}
          className={`mobile-nav-item ${isActive('/trades') ? 'active1' : ''}`}
        >
          <div className="mobile-nav-icon">
            <i className="mdi mdi-history"></i>
          </div>
          <span className="mobile-nav-label">Trades</span>
        </button>


        <button
          onClick={handleChatClick}
          className={`mobile-nav-item`}
        >
          <div className="mobile-nav-icon">
            <i className="mdi mdi-chat"></i>
          </div>
          <span className="mobile-nav-label">Chat</span>
        </button>

        <button
          onClick={handleWalletClick}
          className={`mobile-nav-item ${isActive('/wallet') ? 'active1' : ''}`}
        >
          <div className="mobile-nav-icon">
            <i className="mdi mdi-wallet"></i>
          </div>
          <span className="mobile-nav-label">Wallet</span>
        </button>

        <button
          onClick={handleMenuClick}
          className={`mobile-nav-item ${isActive('/account') ? 'active1' : ''}`}
        >
          <div className="mobile-nav-icon">
            <i className="mdi mdi-account"></i>
          </div>
          <span className="mobile-nav-label">Account</span>
        </button>
      </div>
    </nav>
  );
};

MobileBottomNav.propTypes = {
  isLogged: PropTypes.bool,
  t: PropTypes.func,
  location: PropTypes.object,
  onWalletClick: PropTypes.func,
  onTradesClick: PropTypes.func,
  onChatClick: PropTypes.func,
  onMenuClick: PropTypes.func,
};

export default withRouter(MobileBottomNav);
